import styled from 'styled-components';

import DirectionList from 'components/list/DirectionList';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { ReactComponent as IconWindow } from 'asserts/icons/ic_window_join.svg';
import { ReactComponent as IconSearch } from 'asserts/icons/ic_search_join.svg';
import { ReactComponent as IconData } from 'asserts/icons/ic_data_join.svg';

const Ways = () => {
  return (
    <>
      <InnerWrapper>
        <TitleWrapper>
          <h2>엑스바디 서비스가 처음이신가요?</h2>
          <img src="/images/guide_ticket.png" alt="티켓 이미지" loading="lazy" />
        </TitleWrapper>
        <section>
          <H3>비즈멤버십 구독</H3>
          <Desc>
            엑스바디 검사 서비스는 ‘비즈멤버십’을 적용한 디바이스(PC/키오스크)에서 이용 하실 수
            있습니다.
            <br /> 엑스바디 비즈멤버십을 구독하여 주세요.
          </Desc>
          <IconWrappaer>
            <div>
              <IconWindow />
              <p>
                엑스바디 프로그램
                <br />
                기본 이용권
              </p>
            </div>
            <div>
              <IconSearch />
              <p>
                프로그램을 이용한
                <br />
                검사 서비스 일체
              </p>
            </div>
            <div>
              <IconData />
              <p>
                피검자(고객) 데이터 관리,
                <br /> 검사 데이터 & 리포트 관리
              </p>
            </div>
          </IconWrappaer>
        </section>
      </InnerWrapper>
      <DirectionList HeaderTitle="비즈멤버십 설정방법" />
      <ManageWrapper>
        <h2>비즈멤버십 관리하기</h2>
        <img src="/images/guide_manage.png" alt="비즈멤버십 관리 이미지" loading="lazy" />
        <ManageTextWrapper>
          <h5>마이페이지 &gt; 멤버십관리 메뉴</h5>
          <ul>
            <li>비즈멤버십 설정 변경 (다른 디바이스에 적용하기) </li>
            <li> 비즈멤버십 결제 상세 내역보기, 구독 해지 관리</li>
            <li>인증장비 이름 수정, 삭제 관리</li>
          </ul>
        </ManageTextWrapper>
      </ManageWrapper>
    </>
  );
};

export default Ways;

const InnerWrapper = styled.div`
  width: 890px;
  margin: 0 auto;

  section {
    color: ${color.navyLight};

    p {
      padding: 24px 0 40px;
      ${font.h4_regular};
    }
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  padding: 72px 0 120px;

  img {
    position: absolute;
    top: 0;
    right: -51px;
  }
`;

const IconWrappaer = styled.div`
  display: flex;
  gap: 40px;
  padding-bottom: 128px;

  svg {
    width: 128px;
    height: 128px;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 240px;
    text-align: center;
  }

  p {
    color: ${color.gray600};
    ${font.h4_regular};
  }
`;

const ManageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 128px 0 105px;

  & > h2 {
    padding-bottom: 48px;
  }

  img {
    border-radius: 24px;
    box-shadow: 0px 0px var(--Blur-Blur-16, 16px) 0px
      var(--opacity-black-black-20, rgba(0, 0, 0, 0.2));
  }

  .ant-tabs-nav-wrap {
    justify-content: center;
    padding: 64px 0 48px;

    .ant-tabs-tab {
      font-size: 20px;
      font-weight: 500;
    }
  }
`;

const ManageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  gap: 16px;
  padding: 32px;
  width: 890px;
  border-radius: 24px;
  background: ${color.gray100};
  color: ${color.black2};

  h4 {
    ${font.h2_bold};
  }

  h5 {
    ${font.h4_regular};
  }

  ul {
    margin-left: 8px;
    li {
      ${font.h4_regular};
      display: flex;
      align-items: center;
      gap: 8px;
      &:before {
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: ${color.black2};
        content: '';
      }
    }
  }
`;

const H3 = styled.h3`
  ${font.h1_bold};
  color: ${color.navyLight};
  display: flex;
  align-items: center;
  gap: 16px;
  span {
    ${font.body_regular};
  }
`;

const Desc = styled.p`
  ${font.h4_regular};
  color: ${color.navyLight};
`;
